import { ApiConcept } from 'types/swagger/clarifai-api';
import { postConceptSearches } from 'api-proxy/external/postConceptSearches';

export type ConceptRequest = {
  request: {
    userOrOrgId: string;
    appId: string;
  };
  conceptName: string;
  onlyCurrentAppConcepts?: boolean;
  page: number;
  perPage: number;
};

const PER_PAGE = 512;

export const fetchAllConceptsByName = async (props: Omit<ConceptRequest, 'page' | 'perPage'>): Promise<ApiConcept[] | null> => {
  let page = 1;
  let concepts = [] as ApiConcept[];

  const loopFetchAll = async () => {
    const currentPage = await postConceptSearches({
      ...props,
      page,
      perPage: PER_PAGE,
    });

    if (currentPage) {
      concepts = [...concepts, ...currentPage];

      if (currentPage.length === PER_PAGE) {
        page += 1;
        return loopFetchAll();
      }
    }
    return true;
  };

  const isFetched = await loopFetchAll();

  if (isFetched) {
    return concepts;
  } else {
    throw new Error('Cannot execute fetchAllConceptsByName');
  }
};
